import { META_PLATFORM } from '../config/scheduled-enrichment-platform';
import { useScheduledMetaStore } from '../store/scheduled-meta.store';
import type { EnrichmentContext } from '../types/enrichment-context.types';

import { useScheduledEnrichmentContext } from './scheduled-enrichment-adapter';

/**
 * Builds the {@link EnrichmentContext} for the Meta Ads scheduled enrichment
 * flow. Thin wrapper over the shared scheduled-enrichment core with Meta's
 * platform config and its isolated persisted store.
 */
export function useScheduledMetaEnrichmentContext(): EnrichmentContext {
  return useScheduledEnrichmentContext(META_PLATFORM, useScheduledMetaStore);
}
